import React from 'react';

// Components
import { WpSteps, WpStep } from '../';

const StepsDocs = () => {
  const onNextClick = value => {
    setTimeout(() => {
      console.log('next: ', value);
    }, 5000);
  };

  return (
    <>
      <WpSteps>
        <WpStep title="Personal Profile" subTitle="step one subtitle" onNextClick={() => onNextClick('from step one')}>
          {' '}
          step content goes here
        </WpStep>
        <WpStep
          title="Next Meeting"
          subTitle="Set up your next meeting by typing in your teammate"
          onNextClick={() => onNextClick('from step two')}
        >
          step two content goes here
        </WpStep>
        <WpStep
          title="Create Meeting Agenda"
          subTitle="The agenda allows for structure and consistency in your 1:1 meetings. Start building your agenda by dragging in our suggested topics, or adding in your own!"
        >
          step three content goes here
        </WpStep>
      </WpSteps>
    </>
  );
};

export default StepsDocs;
